import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Check } from 'lucide-react'
import { useAuth } from '@/auth/AuthProvider'
import { Button } from '@/components/ui/controls'
import { AuthShell } from './login'

export const Route = createFileRoute('/upgrade')({ component: UpgradePage })

const INCLUDED = [
  '212,568 matches, 2009–2024',
  'ATP, WTA and Challenger, singles',
  'Search and filter by surface, tour, round, player',
  'Serve and return statistics where available',
  'Pinnacle closing and opening odds',
  'Pre-match Elo, overall and by surface',
]

/**
 * Where a 403 lands — a user who IS signed in but has no active subscription.
 * Deliberately not a login form: telling a subscriber whose card lapsed to
 * "sign in" is the single most maddening thing a paywall can do.
 */
function UpgradePage() {
  const { email, subscribed, signOut } = useAuth()
  const navigate = useNavigate()

  return (
    <AuthShell
      title="Subscribe to continue"
      footer={
        <button
          type="button"
          onClick={() => signOut().then(() => navigate({ to: '/login' }))}
          className="text-muted hover:text-fg hover:underline"
        >
          Sign out
        </button>
      }
    >
      <p className="mb-4 text-sm text-muted leading-relaxed">
        {email ? (
          <>
            Signed in as <span className="text-fg">{email}</span>.{' '}
          </>
        ) : null}
        Full access is $10 per month.
      </p>
      <ul className="mb-6 space-y-2">
        {INCLUDED.map((item) => (
          <li key={item} className="flex items-start gap-2 text-sm text-muted">
            <Check className="mt-0.5 size-3.5 shrink-0 text-win" aria-hidden />
            {item}
          </li>
        ))}
      </ul>
      {subscribed ? (
        <Button
          variant="primary"
          className="w-full"
          onClick={() => navigate({ to: '/matches' })}
        >
          Your subscription is active — continue
        </Button>
      ) : (
        <>
          {/* Billing is not wired up yet; this is where Stripe Checkout goes. */}
          <Button variant="primary" className="w-full" disabled>
            Subscribe — coming soon
          </Button>
          <p className="mt-3 text-center text-xs text-subtle">
            Billing is not connected yet.
          </p>
        </>
      )}
    </AuthShell>
  )
}
